import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import Fade from '@material-ui/core/Fade';
import * as types from "../../constants/actionTypes";
import * as prayerFeatureConsts from "../../constants/prayerFeatureConstants";
import AppointmentTile from "./appointment/appointmentTile";
import AfterVisitSummaryTile from "./appointment/AfterVisitSummaryTile";
import VideoVisitTestLink from "./appointment/VideoVisitTestLink";
import TileLoader from '../common/tileLoader';
import DataComponent from "../common/DataComponent";
import AAUserTile from "../connectedcare/AAUserTile";
import PotentialAAUserTile from "../connectedcare/PotentialAAUserTile";
import AutoLinkModalForHP from '../healthplan/AutoLinkModalForHP';
import MembershipNotificationModal from './MembershipNotificationModal';
import ErrorLoadingTile from "../common/errorLoadingTile";
import * as d from "../../reducers/domainReducer";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import Cookies from "cookies-js";
import { isLoggedIn } from "../../api/ssoApi";
import * as msgs from "../../constants/textConstants";
import Thrive365Tile from "./wellness/Thrive365Tile";
import FluVaccineTile from "./wellness/FluVaccineTile";
import PrayerfeatureTile from "../prayerfeature/PrayerFeatureTile";
import InHomeTile from "../inHome/inHomeTile";
import GiveFeedback from "./GiveFeedback";
import { Divider, Grid, Tooltip, Modal, Button, Icon, Typography, LinkText } from "../ecosystem/";
import GetCareBanner from "./getCare/GetCareBanner";
import HeroBanner from "../dashboard/HeroBanner";
import NoMedicalRecordTile from "../dashboard/NoMedicalRecordTile";
import ResourceTile from "./ResourceTile";
import DashboardSectionHeading from "./DashboardSectionHeading";
import OnboardingDashboardModal from "./OnboardingDashboardModal";
import Discover from './discover/Discover';
import OnboardingCarouselModal from "./OnboardingCarouselModal";
import DashboardPrivacyNotifier from "./DashboardPrivacyNotifier";

const Interactive_InApp_Tutorial = 'InteractiveInAppTutorial';
const ToolTip_GetCareTile = 'tooltip-getcaretile';
const ToolTip_ActionBar = 'tooltip-actionbar';
const ToolTip_ActionBar_Billpay = 'tooltip-actionbar-billpay';
const ToolTip_ActionBar_Completed = 'tooltip-actionbar-completed';
const ToolTip_HeroSection_ProxyPicker = 'tooltip_herosection_proxypicker';
const ToolTip_AppointmentTile = 'tooltip_appointmenttile';
const ToolTip_Discover_New = 'tooltip_discovernew';
const ToolTip_Discover_New_Completed = 'tooltip_discovernew_completed';
const ToolTip_AppointmentTile_Completed = 'tooltip_appointmenttile_completed';

const ToolTip_Phase1_Started = 'tooltip_phase1_started';
const ToolTip_Phase2_Started = 'tooltip_phase2_started';
const ToolTip_Phase3_Started = 'tooltip_phase3_started';
const ToolTip_Phase4_Started = 'tooltip_phase4_started';
const ToolTip_Refresh_AllPhases_Completed = 'tooltip_refresh_allphases_completed';
const OnBoarding_Modal = 'onboarding_modal';
const OnBoarding_Modal_Dismiss = 'onboarding_modal_dismiss';

/**
 * Container component for the dashboard page.
 * 
 */
class Dashboard extends DataComponent {

    constructor(props) {
        super(props);

        this.loadData = this.loadData.bind(this);
        this.shouldLoadData = this.shouldLoadData.bind(this);
        this.loadUserTilesForMyChartUsers = this.loadUserTilesForMyChartUsers.bind(this);
        this.getUserTiles = this.getUserTiles.bind(this);
        this.onBoardingDashboardModalDismissed = this.onBoardingDashboardModalDismissed.bind(this);

        this.state = {
            showInteractiveTutorial: window.location.search === "?whatsnew=1",
            showVaccineTile: false,
            vaccineTileIsDismissed: false,
            onBoardingToolTipState: ''
        };

        this.isCovidVaxSearchComplete = false;
    }

    componentDidCatch(ex, info) {
        let json = {
            error: ex,
            componentStack: info
        };
        logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(ex), JSON.stringify(info));
    }

    componentDidUpdate(prevProps) {
        const {
            isProxyUser,
            isCovidVaxScheduleEligible,
            currentUser,
            currentMyChartUser,
            enableFluVaccine,
            isActiveFeature_FluShot,
            hideFluVaccineTile,
            enableCovidScheduleAuthFeature,
            showOnBoardingPhaseOneToolTipWeb,
            hasMyChartLogin,
            membershipNotification,
            hasSeenMembershipNotification,
            serviceWaiting,
            showOnBoardingPhaseTwoToolTipWeb,
            showOnBoardingPhaseThreeToolTipWeb,
            showOnBoardingPhaseFourToolTipWeb,
            isBSWHPrivacyAccepted,
            bswhPrivacydata
        } = this.props;

        const { onBoardingToolTipState } = this.state;

        if (prevProps && ((prevProps.isCovidVaxScheduleEligible !== isCovidVaxScheduleEligible) || (prevProps.currentMyChartUser && currentMyChartUser && prevProps.currentMyChartUser.ageYears !== currentMyChartUser.ageYears)) && (enableCovidScheduleAuthFeature === false || (enableCovidScheduleAuthFeature && isCovidVaxScheduleEligible))) {
            if (prevProps.currentUser && currentUser && prevProps.currentUser.eid !== currentUser.eid) {
                this.searchGenericProvidersForSlotAvailability();
            } else if (!this.isCovidVaxSearchComplete) { // Avoid multiple calls from did mount.
                this.searchGenericProvidersForSlotAvailability();
            }
        }

        if (prevProps && ((prevProps.hideFluVaccineTile !== hideFluVaccineTile) || prevProps.isProxyUser !== isProxyUser)) {
            this.setState({
                showVaccineTile: enableFluVaccine && !isProxyUser && isActiveFeature_FluShot && hideFluVaccineTile !== null && !hideFluVaccineTile
            })
        }

        // show OnBoarding Tooltip only after the membership modal is dismissed
        if (onBoardingToolTipState === '' && (showOnBoardingPhaseOneToolTipWeb || showOnBoardingPhaseTwoToolTipWeb || showOnBoardingPhaseThreeToolTipWeb || showOnBoardingPhaseFourToolTipWeb) && hasMyChartLogin && ((bswhPrivacydata && !bswhPrivacydata.error && isBSWHPrivacyAccepted) || (bswhPrivacydata && bswhPrivacydata.error)) && (membershipNotification ? hasSeenMembershipNotification : !serviceWaiting)) {
            if (showOnBoardingPhaseOneToolTipWeb) {
                this.setState({
                    onBoardingToolTipState: OnBoarding_Modal
                });
            } else if (showOnBoardingPhaseTwoToolTipWeb) {
                this.setState({
                    onBoardingToolTipState: ToolTip_Phase2_Started
                });
            } else if (showOnBoardingPhaseThreeToolTipWeb) {
                this.setState({
                    onBoardingToolTipState: ToolTip_Phase3_Started
                });
            } else if (showOnBoardingPhaseFourToolTipWeb) {
                this.setState({
                    onBoardingToolTipState: ToolTip_Phase4_Started
                });
            }
        }
    }

    componentDidMount() {
        if (super.componentDidMount) {
            super.componentDidMount();
        }
        const {
            isProxyUser,
            isLoggedIn,
            enableFluVaccine,
            isActiveFeature_FluShot,
            hideFluVaccineTile
        } = this.props;
        if (isLoggedIn) {
            logUI("MBHWeb.Dashboard.ComponentDidMount", new Date(), Tools.getURLPath());
        }

        this.setState({
            showVaccineTile: enableFluVaccine && !isProxyUser && isActiveFeature_FluShot && hideFluVaccineTile !== null && !hideFluVaccineTile
        })
    }

    searchGenericProvidersForSlotAvailability = () => {
        const {
            CovidVaccineMaximumSearchRadius,
            isCovidVaxScheduleEligible,
            enableCovidScheduleAuthFeature,
            searchGenericProvidersForSlotAvailability,
            serverData,
            latitude,
            longitude,
            currentMyChartUser
        } = this.props;
        if ((enableCovidScheduleAuthFeature && !isCovidVaxScheduleEligible) || (serverData && !serverData.allowDashboardSlotSearch) || !(currentMyChartUser && currentMyChartUser.ageYears))
            return;

        if (latitude === null || latitude === 0) {
            logUI("MBHWeb.Dashboard.GenericProvider.Search.LocationNotFound", new Date(), Tools.getURLPath());
            return;
        }
        let locationQueryString = latitude + ',' + longitude;
        let isMinor = 17 >= currentMyChartUser.ageYears;
        let genericSearchModel = {
            location: "[" + locationQueryString.trim() + "]",
            radius: CovidVaccineMaximumSearchRadius,
            sortBy: "Distance",
            visitTypeId: isMinor ? serverData.covid19VaccineVisitTypeIdForMinor : serverData.covid19VaccineVisitTypeId,
            page: "1",
            perPage: "12"
        };

        searchGenericProvidersForSlotAvailability(genericSearchModel, () => { })
        this.isCovidVaxSearchComplete = true;
    }

    shouldLoadData() {
        return this.props.isLoggedIn;
    }

    loadUserTilesForMyChartUsers(dashboardData) { // Load for mychart users
        this.getUserTiles();
    }

    getUserTiles() {
        logUI("MBHWeb.Dashboard.GetUserTiles", new Date(), Tools.getURLPath());
        this.props.getUserTilesByClientData();
    }

    onBoardingDashboardModalDismissed() {
        logUI("MBHWeb.Dashboard.onBoardingDashboardModalDismissed", new Date(), Tools.getURLPath());
        this.setState({
            onBoardingToolTipState: OnBoarding_Modal_Dismiss
        });
        this.props.dismissOnBoardingPhaseOneToolTipPreference();
        this.props.dismissOnBoardingPhaseTwoToolTipPreference();
        this.props.dismissOnBoardingPhaseThreeToolTipPreference();
        this.props.dismissOnBoardingPhaseFourToolTipPreference();
    }

    loadData() {
        try { // debugger;
            const {
                hasMyChartLogin,
                hasAAL,
                hasFirstCare,
                hasHealthPlanLogin,
                isNewHealthPlanEnabled,
                isCovidVaxScheduleEligible,
                enableCovidScheduleAuthFeature,
                enableFluVaccine,
                isShowAllUsers
            } = this.props;

            if (hasMyChartLogin) { // debugger;
                this.props.getDashboardData(isShowAllUsers, this.loadUserTilesForMyChartUsers); // so nevermind, reload on each visit  <-- this is one is directly wired to events, the rest should be
            } else { // Load for non mychart users
                this.getUserTiles(); // not restricting the loading as of now.
            }

            if ((enableCovidScheduleAuthFeature === false || (enableCovidScheduleAuthFeature && isCovidVaxScheduleEligible)) && !this.isCovidVaxSearchComplete)
                this.searchGenericProvidersForSlotAvailability();


            // if (this.props.hasHealthPlanLogin) {
            //    this.props.getHealthPlanDashBoardData();
            // }

            this.props.getThriveDashboardData(this.props.authToken);

            if (enableFluVaccine) {
                this.props.getFluStatus(this.props.authToken);
            }

            if (hasAAL || (isNewHealthPlanEnabled && (hasHealthPlanLogin || hasFirstCare))) {
                this.props.getHealthPlanData();
            }
        } catch (E) { // debugger;
            logUI("MBHWeb.Dashboard.Load.Failure", new Date(), Tools.getURLPath());
            console.error(E);
        }
    }

    onNotificationResponse = (response, id) => {
        const { setMembershipUserNotificationResponse } = this.props
        setMembershipUserNotificationResponse(response, id)
    }

    updateGetCareToolTipPreference = () => {
        const { updateGetCareToolTipPreference, updateScheduleCareToolTipPreference, refreshFamilyManagementTooltip, hasSeenScheduleCareTooltip } = this.props;
        /* if (updateGetCareToolTipPreference) {
             updateGetCareToolTipPreference();
             refreshFamilyManagementTooltip();
         }*/
        if (updateScheduleCareToolTipPreference) {
            updateScheduleCareToolTipPreference();
            refreshFamilyManagementTooltip();
            hasSeenScheduleCareTooltip();
        }
    }

    dismissFluTile = (e) => {
        this.setState({ vaccineTileIsDismissed: true })
    }

    removeFluVaccineTile = () => {
        if (this.state.vaccineTileIsDismissed) {
            this.setState({ showVaccineTile: false })
            this.props.dispatchDismissFluTile();
        }
    }

    updateonBoardingToolTipState = (currentState) => {
        const { dismissOnBoardingPhaseOneToolTipPreference, dismissOnBoardingPhaseTwoToolTipPreference, dismissOnBoardingPhaseThreeToolTipPreference, dismissOnBoardingPhaseFourToolTipPreference, showOnBoardingPhaseOneToolTipWeb, showOnBoardingPhaseTwoToolTipWeb, showOnBoardingPhaseThreeToolTipWeb, showOnBoardingPhaseFourToolTipWeb } = this.props;
        if (currentState && currentState === ToolTip_Refresh_AllPhases_Completed) {
            if (showOnBoardingPhaseOneToolTipWeb) {
                dismissOnBoardingPhaseOneToolTipPreference();
            }
            if (showOnBoardingPhaseTwoToolTipWeb) {
                dismissOnBoardingPhaseTwoToolTipPreference();
            }
            if (showOnBoardingPhaseThreeToolTipWeb) {
                dismissOnBoardingPhaseThreeToolTipPreference();
            }
            if (showOnBoardingPhaseFourToolTipWeb) {
                dismissOnBoardingPhaseFourToolTipPreference();
            }
            logUI("MBHWeb.Dashboard.onBoardingDashboardToolTipsCompleted", new Date(), Tools.getURLPath());
        }
        this.setState({ onBoardingToolTipState: currentState });
    }

    doUpdateThriveTooltipPreference = () => {
        const { updateThriveTooltipPreference } = this.props;
        if (updateThriveTooltipPreference) {
            updateThriveTooltipPreference();
        }
    }

    updateNoMedicalRecordToolTip = () => {
        const { dismissNoMedicalRecordToolTip } = this.props;
        dismissNoMedicalRecordToolTip();
    }

    acceptBSWHPrivacy = () => {
        const { acceptBSWHPrivacyText } = this.props;
        acceptBSWHPrivacyText(msgs.Privacy_MyBswh_VersionId);
    }

    getCurrentAvsByProfile(avs) {
        const { isShowAllUsers, currentMyChartUser } = this.props;
        let avsList = [];
        if (avs && avs.length > 0) {
            if (isShowAllUsers) {
                return avs;
            } else if (currentMyChartUser && currentMyChartUser.externalId) {
                for (let i = 0; i < avs.length; i++) {
                    if (avs[i] && avs[i].patientExternalId &&
                        avs[i].patientExternalId === currentMyChartUser.externalId) {
                        avsList.push(avs[i]);
                    }
                }
            }
        }
        return avsList;
    }
    filterDiscoverTiles() {
        return this.props.tiles.filter(tile => {
            if (tile.tags.indexOf('video-visit') !== -1) {
                const { currentUser } = this.props.bffDashboardData.data;
                return currentUser?.pastAppointment?.lastVideoVisitDate ? false : true;
            } else if (tile.tags.indexOf('in-home-vaccine') !== -1) {
                const enableInHomeFeature = window.serverData.data.enableInHomeFeature;
                const { isActiveFeature_InHomeVaccine, isActiveFeatureAnyone_InHomeVaccine } = this.props;
                return enableInHomeFeature && (isActiveFeature_InHomeVaccine || !this.props.isProxyUser && isActiveFeatureAnyone_InHomeVaccine);
            } else if (this.props.isProxyUser) {
                return tile.tags.indexOf("notForProxy") === -1;
            }
            return true;
        }
        );
    }
    render() {
        var isClientSide = typeof window !== 'undefined';

        const {
            swhpDown,
            epicEHRDown,
            hasMyChartLogin,
            hasHealthPlanLogin,
            dashboardData,
            serviceWaiting,
            serviceError,
            todos,
            todosWaiting,
            todosError,
            healthPlanUrl,
            healthPlanCardUrl,
            healthPlanData,
            healthPlanServiceWaiting,
            healthPlanServiceError,
            healthSourceData,
            healthSourceServiceError,
            healthSourceWaiting,
            serverData,
            userDetails,
            isProxyUser,
            isEmployee,
            isLoggedIn,
            thriveDataSuccess,
            hasAAL,
            aalDown,
            hasFirstCare,
            hasAutoMyChart,
            showAutoLinkMyChart,
            autolinkMyChartSuccess,
            bffDashboardData,
            currentMyChartUser,
            bffDashboardError,
            showGetCareToolTip,
            updateGetCareToolTipPreference,
            currentHealthPlanInfo,
            hasPharmacyFeature,
            isActiveFeature_InsuranceModule,
            isActiveFeature_InHomeVaccine,
            isActiveFeatureAnyone_InHomeVaccine,
            enableWellnessTiles,
            membershipNotification,
            enablePrayerFeature,
            isActiveFeature_Amity,
            communitySupportBanned,
            enableV2MembershipLinking,
            enableInHomeFeature,
            showScheduleCareTooltip,
            hasSeenMembershipNotification,
            showThriveTooltip,
            updateThriveTooltipPreference,
            hasSeenScheduleCareTooltipAlready,
            userMemberships,
            screenBreakPoint,
            technicalHelpDeskNumber,
            showLinkMedicalRecordPhaseOneToolTip,
            isMyChartInActive,
            isShowAllUsers,
            roles,
            showOnBoardingPhaseThreeToolTipWeb,
            isDashboardMenuCollapsed,
            bswhPrivacydata,
            isBSWHPrivacyAccepted,
            acceptBSWHPrivacyPolicyText,
            removeBSWPharmacy
        } = this.props;

        const enableAALElements = serverData.enableAA && hasAAL;
        const hasAutoHp = currentHealthPlanInfo && currentHealthPlanInfo.Auto ? currentHealthPlanInfo.Auto : false;

        const HealthSourceData = healthSourceData ? healthSourceData : [];
        const enableThrive365Tile = window.serverData.data.enableThrive365Tile;

        const appointments = hasMyChartLogin && bffDashboardData && bffDashboardData.data && bffDashboardData.data.appointments ? bffDashboardData.data.appointments : null;

        const avsList = hasMyChartLogin && bffDashboardData && bffDashboardData.data && bffDashboardData.data.avs ? this.getCurrentAvsByProfile(bffDashboardData.data.avs) : null;

        const isPOC = roles ? roles.toLowerCase().indexOf("video_poc") >= 0 : false;
        const ambulatoryVideoEnabled = serverData && serverData.ambulatoryVideoVisitEnabled;
        const showTestVideoLink = ambulatoryVideoEnabled && hasMyChartLogin && isPOC && !isProxyUser;

        //const { internalId } = currentMyChartUser || "";
        //if (currentMyChartUser && (appointments && internalId && internalId in appointments)) {
        //    const tempAppointments = appointments[internalId];
        //    // API returns the appointments in order now and we can pick the first item from appointments[internalId] but still sorting it just to be sure. Picking latest appointment.
        //    tempAppointments.sort((a, b) => {
        //        const dtA = new Date(a.appointmentDateTime);
        //        const dtB = new Date(b.appointmentDateTime);
        //        return dtA > dtB ? 1 : -1;
        //    });
        //    appointmentDetails = tempAppointments;
        //}

        const hasSWNTMembership = userMemberships && userMemberships.some(membership => membership.membershipKey.toUpperCase() === 'SWNT');
        const hasSWHPMembership = userMemberships && userMemberships.some(membership => membership.membershipKey.toUpperCase() === 'SWHP');
        const isMobile = !(screenBreakPoint === msgs.XL_DESKTOP || screenBreakPoint === msgs.XXL_DESKTOP) ? true : false;
        const isDesktop = (screenBreakPoint === msgs.XXL_DESKTOP) ? true : false;
        const onboardingCarouselDesktop = (screenBreakPoint === msgs.LG_TABLET || screenBreakPoint === msgs.XL_DESKTOP || screenBreakPoint === msgs.XXL_DESKTOP) ? true : false;
        const disableMyChartTiles = !hasMyChartLogin || isMyChartInActive || epicEHRDown;

        const resourcesColumn = (<>
            <DashboardSectionHeading heading="Resources" isMobile={isMobile} mTop={isMobile && "xl"} />
            {
                !isProxyUser && enablePrayerFeature && isActiveFeature_Amity && !communitySupportBanned &&
                <PrayerfeatureTile isMobile={isMobile} />
            }
            <ResourceTile isProxyUser={isProxyUser} hasPharmacyFeature={removeBSWPharmacy === false && hasPharmacyFeature}
                hasMyChartLogin={hasMyChartLogin} disableMyChartTiles={disableMyChartTiles}
                serverData={serverData} isMobile={isMobile}
                isActiveFeature_InsuranceModule={isActiveFeature_InsuranceModule} enableAALElements={enableAALElements}
                swhpDown={swhpDown} aalDown={aalDown} hasHealthPlanLogin={hasHealthPlanLogin} hasFirstCare={hasFirstCare}
            />
        </>);

        const { onBoardingToolTipState } = this.state;
        const tooltipText = "Looking for upcoming appointments and after visit  summaries? You can now find them here for all members of your family.";
        const discoverNewTooltipText = "Hey there! We've launched a new section to help you get the most out of MyBSWHealth. See features and content to aid in your health journey."
        const tooltipLinkText = "Okay, got it!";

        const showOnBoardingRefreshCarouselModal = (onBoardingToolTipState === ToolTip_Phase1_Started || onBoardingToolTipState === ToolTip_Phase2_Started || onBoardingToolTipState === ToolTip_Phase3_Started || onBoardingToolTipState === ToolTip_Phase4_Started);

        try {

            return (
                <Grid className={`body-content dashboard-container`}>
                    {!isProxyUser && !enableV2MembershipLinking && hasAutoHp &&
                        <AutoLinkModalForHP />}

                    {enableV2MembershipLinking && membershipNotification &&
                        <MembershipNotificationModal autoLinkNotifications={membershipNotification} onNotificationResponse={this.onNotificationResponse} />
                    }

                    <DashboardPrivacyNotifier isOpen={bswhPrivacydata && !bswhPrivacydata.isFetching && !bswhPrivacydata.error && !isBSWHPrivacyAccepted && acceptBSWHPrivacyPolicyText && !acceptBSWHPrivacyPolicyText.isFailure} okBtnOnclick={() => { this.acceptBSWHPrivacy(); }} />

                    <OnboardingDashboardModal isOpen={onBoardingToolTipState === OnBoarding_Modal}
                        onStarted={(e) => {
                            this.setState({ onBoardingToolTipState: ToolTip_Phase1_Started });
                            logUI("MBHWeb.Dashboard.onBoardingDashboard.PhaseOne.Started", new Date(), Tools.getURLPath());
                        }}
                        onBoardingToolTipState={onBoardingToolTipState}
                        onDismiss={(e) => { this.onBoardingDashboardModalDismissed(); }}
                    />
                   
                    {showOnBoardingRefreshCarouselModal && <OnboardingCarouselModal isOpen={showOnBoardingRefreshCarouselModal}
                        onDismiss={(value) => { this.updateonBoardingToolTipState(value); }}
                        isMobile={!onboardingCarouselDesktop}
                        isDesktop={onboardingCarouselDesktop}
                        onBoardingToolTipState={onBoardingToolTipState}
                        OnCloseBtn={(e) => {
                            this.onBoardingDashboardModalDismissed();
                        }}
                    />}

                    <HeroBanner screenBreakPoint={screenBreakPoint} isOpenHeroSectionToolTip={onBoardingToolTipState === ToolTip_HeroSection_ProxyPicker} updateonBoardingToolTipState={e => this.setState({ onBoardingToolTipState: ToolTip_AppointmentTile })} />
                    <div className="row dashboard__quick-links">
                        <div className="col-12">
                            <GetCareBanner
                                isMobile={isMobile}
                                isDesktop={isDesktop}
                                showGetCareTileToolTip={onBoardingToolTipState === ToolTip_GetCareTile}
                                openActionBarToolTip={e => this.setState({ onBoardingToolTipState: ToolTip_ActionBar })}
                                disabled={disableMyChartTiles}
                                dashBoardDetails={bffDashboardData}
                                isShowAllUsers={isShowAllUsers}
                                onBoardingToolTipState={onBoardingToolTipState}
                                updateonBoardingToolTipState={(value) => {
                                    this.setState({
                                        onBoardingToolTipState: value
                                    })
                                }}

                            />
                        </div>
                        {
                            (!hasMyChartLogin && !epicEHRDown) &&
                            <div className="col-12 maxWidth-content no-medical-record-tile-container">
                                <NoMedicalRecordTile isMobile={isMobile} technicalHelpDeskNumber={technicalHelpDeskNumber} showToolTip={showLinkMedicalRecordPhaseOneToolTip} updateNoMedicalRecordToolTip={this.updateNoMedicalRecordToolTip} />
                            </div>
                        }
                    </div>
                    <div className="row dashboard__divider">
                        <Divider mTop="none" mBottom="small" mRight="none" mLeft="none" />
                    </div>
                    <div className="row">
                        <div className="col-12 maxWidth-content">
                            <div className="row">
                                <div className="col-12 col-lg-7 col-xl-8 dashboard__main">
                                    <Tooltip open={onBoardingToolTipState === ToolTip_AppointmentTile}
                                        text={tooltipText}
                                        tooltipId="appt-tooltip"
                                        linkText={"Continue"}
                                        variant="spotlight"
                                        linkOnClick={
                                            () => {
                                                this.updateonBoardingToolTipState(ToolTip_Discover_New);
                                            }
                                        }
                                    >
                                        <div className="appt-tile-tooltip">
                                            <DashboardSectionHeading
                                                disabled={disableMyChartTiles}
                                                heading="Next Appointments"
                                                isMobile={isMobile}
                                                mBottom={showTestVideoLink && 'none'}
                                                sideLink={{
                                                    label: "See All",
                                                    onClick: () => logUI("MBHWeb.Dashboard.AppointmentTile.AppointmentDetails.Click", new Date(), Tools.getURLPath()),
                                                    url: "/familyselection/appointments"
                                                }}
                                            />
                                        </div>
                                    </Tooltip>
                                    {showTestVideoLink &&
                                        <VideoVisitTestLink />
                                    }
                                    {
                                        !bffDashboardError
                                            ? <AppointmentTile appointments={appointments} isMobile={isMobile} />
                                            : <ErrorLoadingTile error="true"
                                                errorMsg="Not available. Please try again later." />
                                    }

                                    {avsList &&
                                        avsList?.map((avs, index) => <AfterVisitSummaryTile key={'avs_' + index} avs={avs} isMobile={isMobile} />)}

                                    {isMobile && resourcesColumn}
                                    <Tooltip open={onBoardingToolTipState === ToolTip_Discover_New}
                                        text={discoverNewTooltipText}
                                        placement="top"
                                        tooltipId="discover-tooltip"
                                        linkText={tooltipLinkText}
                                        variant="spotlight"
                                        linkOnClick={
                                            () => {
                                                this.updateonBoardingToolTipState(ToolTip_Discover_New_Completed);
                                            }
                                        }
                                        scrollIntoView
                                    >
                                        <Discover tiles={this.filterDiscoverTiles()} isMobile={isMobile} />
                                    </Tooltip>
                                    <GiveFeedback enabled={window.serverData.data.enableQualtricsSurveyDashboard} />
                                    {/*
                                        enableInHomeFeature && (isActiveFeature_InHomeVaccine || !isProxyUser && isActiveFeatureAnyone_InHomeVaccine) &&
                                        <InHomeTile />
                                   */ }

                                    {this.state.showVaccineTile &&
                                        <Fade in={!this.state.vaccineTileIsDismissed} timeout={{ enter: 0, exit: 500 }} onTransitionEnd={this.removeFluVaccineTile}>

                                            <FluVaccineTile dismissFluTile={this.dismissFluTile} />

                                        </Fade>
                                    }

                                    {enableWellnessTiles && enableThrive365Tile && !isProxyUser && isEmployee &&
                                        <Thrive365Tile showThriveTooltip={(isEmployee || hasSWNTMembership) && (showThriveTooltip) && (hasSeenScheduleCareTooltipAlready || !showScheduleCareTooltip)}
                                            doUpdateThriveTooltipPreference={this.doUpdateThriveTooltipPreference}
                                            hasSWNTMembership={hasSWNTMembership} hasSWHPMembership={hasSWHPMembership}
                                        />
                                    }
                                </div>
                                {!isMobile &&
                                    <div className="col-12 col-lg-5 col-xl-4 dashboard__sidebar">
                                        {resourcesColumn}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </Grid>
            );

        } catch (ex) {
            console.error(ex);
            return <div>Exception rendering!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! {ex}</div>;
        }
    }
}

const mapStateToProps = (state) => {
    const windowDefined = typeof window !== 'undefined';
    return {
        userDetails: state.sso.userDetails,
        isLoggedIn: state.domain.li,
        hasMyChartLogin: state.domain.hm,
        hasHealthPlanLogin: state.memberships.hasAnySWHP,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        hasAAL: state.memberships.hasAA,
        rxDown: state.common.rxDown,
        epicEHRDown: state.common.epicEHRDown,
        swhpDown: state.common.swhpDown,
        aalDown: state.common.aalDown,
        isNewHealthPlanEnabled: state.session.serverData && state.session.serverData.enableNewHealthPlan,
        hasFirstCare: state.memberships.hasFC,
        dashboardData: state.dashboard.dashBoardDetails,
        isShowAllUsers: state.dashboard.isShowAllUsers,
        serviceWaiting: state.dashboard.isWaiting ? state.dashboard.isWaiting : false,
        serviceError: state.dashboard.error || state.dashboard.isEpicDashboardError,
        todosError: state.dashboard.todosError,
        healthSourceData: state.healthSource.healthSourceDashboardDetails,
        healthSourceServiceError: state.healthSource.healthSourceError,
        healthSourceWaiting: state.healthSource.isFetching,
        authToken: state.domain.t,
        isProxyUser: state.domain.ip,
        serverData: state.session.serverData,
        hideFluVaccineTile: state.portal.hideFluVaccineTile,
        isEmployee: state.domain.ie,
        thriveData: state.thrive.card,
        thriveDataSuccess: state.thrive.cardSuccess,
        showAutoLinkMyChart: state.session.showAutoLinkMyChart,
        hasAutoMyChart: state.domain.amc,
        autolinkMyChartSuccess: state.healthSource.autolinkMyChartSuccess,
        bffDashboardData: state.dashboard.bffDashboardData,
        membershipNotification: state.dashboard.bffDashboardData?.membershipNotification,
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        roles: state.sso.userDetails ? state.sso.userDetails.Roles : "",
        bffDashboardError: state.dashboard.bffDashboardData && state.dashboard.bffDashboardData.error,
        showGetCareToolTip: state.session.showGetCareToolTip,
        showScheduleCareTooltip: state.session.showScheduleCareTooltip,
        currentHealthPlanInfo: state.session.currentHealthPlanInfo,
        noActiveDCJEids: state.session.noActiveDCJEids,
        hasPharmacyFeature: state.memberships.hasPharmacyFeature,
        // isActiveFeature_Pharmacy: state.memberships.isActiveFeature_Pharmacy,
        isActiveFeature_AmbulatoryVideoVisit: state.memberships.isActiveFeature_AmbulatoryVideoVisit,
        isActiveFeature_SDCVideoVisit: state.memberships.isActiveFeature_SDCVideoVisit,
        isActiveFeature_FluShot: state.memberships.isActiveFeature_FluShot,
        isActiveFeature_InHomeVaccine: state.memberships.isActiveFeature_InHomeVaccine,
        isActiveFeatureAnyone_InHomeVaccine: state.memberships.isActiveFeatureAnyone_InHomeVaccine,
        enableWellnessTiles: state.memberships.isActiveFeature_Wellness,
        enableInHomeFeature: state.session.serverData.enableInHomeFeature,
        isCovidVaxScheduleEligible: state.memberships.hasAuthorizedFeatureSchedCovidVax,
        isActiveFeature_Amity: state.memberships.activeFeatures && state.memberships.activeFeatures.amity,
        communitySupportBanned: state.session.userPreferences && state.session.userPreferences[prayerFeatureConsts.COMMUNITY_SUPPORT_BANNED],
        enablePrayerFeature: state.session.serverData && state.session.serverData.enablePrayerFeature,
        enableCovidScheduleAuthFeature: state.session.serverData && state.session.serverData.enableCovidScheduleAuthFeature ? state.session.serverData.enableCovidScheduleAuthFeature : false,
        roles: state.sso.userDetails ? state.sso.userDetails.Roles : "",
        currentUser: state.header && state.memberships.currentUser ? state.memberships.currentUser : {},
        enableFluVaccine: state.session.serverData && state.session.serverData.enableFluVaccine ? true : false,
        enableV2MembershipLinking: state.session.serverData && state.session.serverData.enableV2MembershipLinking ? true : false,
        CovidVaccineMaximumSearchRadius: state.session.serverData && state.session.serverData.CovidVaccineMaximumSearchRadius ? state.session.serverData.CovidVaccineMaximumSearchRadius : "250",
        isActiveFeature_InsuranceModule: state.memberships.hasAnySWHP || state.memberships.hasFC || (state.session.serverData?.enableAA && state.memberships.hasAA),
        latitude: state.domain.lt,
        longitude: state.domain.ln,
        hasSeenMembershipNotification: state.dashboard.hasSeenMembershipNotification,
        showThriveTooltip: state.session.showThriveTooltip,
        hasSeenScheduleCareTooltipAlready: state.session.hasSeenScheduleCareTooltip,
        userMemberships: state.memberships?.membershipData?.memberships,
        screenBreakPoint: state.common.screenBreakPoint,
        technicalHelpDeskNumber: state.session.serverData ? state.session.serverData.technicalHelpDeskNumber : "",
        showOnBoardingPhaseOneToolTipWeb: state.portal.showOnBoardingPhaseOneToolTipWeb,
        showOnBoardingPhaseTwoToolTipWeb: state.portal.showOnBoardingPhaseTwoToolTipWeb,
        showOnBoardingPhaseThreeToolTipWeb: state.portal.showOnBoardingPhaseThreeToolTipWeb,
        showOnBoardingPhaseFourToolTipWeb: state.portal.showOnBoardingPhaseFourToolTipWeb,
        showLinkMedicalRecordPhaseOneToolTip: state.portal.showLinkMedicalRecordPhaseOneToolTip,
        isMyChartInActive: state.dashboard.isMyChartInActive,
        tiles: state?.dashboard?.bffDashboardData?.data?.userAppTiles?.tiles ?? [],
        isNavMenuCollpsed: state.domain.dmc,
        bswhPrivacydata: state.docs.bswhPrivacydata,
        isBSWHPrivacyAccepted: state.docs.isBSWHPrivacyAccepted,
        acceptBSWHPrivacyPolicyText: state.portal.acceptPrivacyPolicyText,
        removeBSWPharmacy: state.session.serverData ? state.session.serverData.removeBSWPharmacy : false
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getDashboardData: (isSeeAllSelected, callback) => dispatch(
            { type: types.LOAD_DASHBOARD_START, isSeeAllSelected: isSeeAllSelected, callback: callback }
        ),
        getUserTilesByClientData: () => dispatch(
            { type: types.LOAD_HEALTHSOURCEDASHBOARD_START }
        ),
        logError: (error) => dispatch(
            { type: types.APPLICATION_ERROR, error: error }
        ),
        getThriveDashboardData: (token) => {
            dispatch({ type: types.THRIVE_GET_CARD, token: token });
        },
        getFluStatus: (token) => {
            dispatch({ type: types.GET_COMPLETE_FLU_STATUS, token: token });
        },
        getHealthPlanData: () => {
            dispatch({ type: types.LOAD_HEALTHPLAN_DATA_START });
        },
        updateGetCareToolTipPreference: () => {
            dispatch({ type: types.UPDATE_GETCARE_TOOLTIP_PREFERENCE });
        },
        updateScheduleCareToolTipPreference: () => {
            dispatch({ type: types.UPDATE_SCHEDULE_CARE_TOOLTIP_PREFERENCE });
        },
        searchGenericProvidersForSlotAvailability: (searchModel, callback) => {
            dispatch({ type: types.SEARCH_FOR_GENERIC_PROVIDER_SLOT_AVAILABILITY, searchModel: searchModel, callback: callback });
        },
        refreshFamilyManagementTooltip: () => {
            dispatch({ type: types.REFRESH_FAMILY_MANAGEMENT_TOOLTIP });
        },
        dispatchDismissFluTile: () => {
            dispatch({ type: types.DISMISS_FLU_TILE });
        },
        setMembershipUserNotificationResponse: (response, messageId) => {
            dispatch({ type: types.SET_MEMBERSHIP_NOTI_RESPONSE, response: response, id: messageId });
        },
        updateThriveTooltipPreference: () => {
            dispatch({ type: types.UPDATE_THRIVE_TOOLTIP_PREFERENCE })
        },
        hasSeenScheduleCareTooltip: () => {
            dispatch({ type: types.HAS_SEEN_SCHEDULE_CARE_TOOLTIP });
        },
        dismissOnBoardingPhaseOneToolTipPreference: () => {
            dispatch({ type: types.DISMISS_ONBOARDING_PHASEONE_TOOLTIP });
        },
        dismissOnBoardingPhaseTwoToolTipPreference: () => {
            dispatch({ type: types.DISMISS_ONBOARDING_PHASETWO_TOOLTIP });
        },
        dismissOnBoardingPhaseThreeToolTipPreference: () => {
            dispatch({ type: types.DISMISS_ONBOARDING_PHASETHREE_TOOLTIP });
        },
        dismissOnBoardingPhaseFourToolTipPreference: () => {
            dispatch({ type: types.DISMISS_ONBOARDING_PHASEFOUR_TOOLTIP });
        },
        dismissNoMedicalRecordToolTip: () => {
            dispatch({ type: types.DISMISS_LINK_MEDICALRECORD_PHASEONE_TOOLTIP });
        },
        acceptBSWHPrivacyText: (versionId) => {
            dispatch({ type: types.UPDATE_PRIVACY_MYBSWH_ACCEPTED });
            dispatch({ type: types.ACCEPT_BSW_DIGITAL_PRIVACY_POLICY, versionId: versionId });
        }
    };
};

const DashboardComp = withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard));

export default DashboardComp;
